// extracted by mini-css-extract-plugin
export var container = "styles-module--container--1Fx6v";
export var padsWrapper = "styles-module--padsWrapper--3mLhr";
export var samplerIcon = "styles-module--samplerIcon--3Av-x";
export var cta = "styles-module--cta--1nf4s";
export var pulse = "styles-module--pulse--2LoEl";
export var hideUI = "styles-module--hideUI--2xAfJ";